// extracted by mini-css-extract-plugin
export default {"dps-product-group-header":"dpsProductGroupHeader_dps-product-group-header__qVAjU","dpsproduct-group-category":"dpsProductGroupHeader_dpsproduct-group-category__degAQ"};